<template>
  <button @click="isSignalModalOpen = true" class="btn">
    <PhWarning class="w-5 h-5"/> Report signal
  </button>
  <modal :isOpen="isSignalModalOpen" @close="isSignalModalOpen = false">
    <template #header>
      <h3 class="font-bold text-lg ">{{ "Report a signal" }}</h3>
    </template>
    <form @submit.prevent="upsertSignal">
      <label class="label font-semibold text-xs text-base-content/70">Title</label>
      <textarea
          v-model="form.title"
          class="textarea textarea-bordered h-24 w-full text-sm"
          placeholder="Detail technical actions, measurements taken, and adjustments..."
      ></textarea>
    </form>

  </modal>
</template>
<script setup lang="ts">
import Modal from "~/components/common/modal.vue";
import {ref} from "vue";
import {upsertSignal} from "~/lib/api/machine_signals";
import {PhWarning} from "@phosphor-icons/vue";

let isSignalModalOpen = ref(false);
let props = defineProps(['signal',  'orgUUID', 'machineId']);
let {signal, orgUUID, machineId} = props;
let emit = defineEmits(['onCreate', 'onCreateError', 'onCancel']);
let form = ref(signal || {title: ""});


const _upsertSignal = async () => {
  let res = await upsertSignal(orgUUID, machineId, {
    machine_signal: {}
  });

  if (res.status === 201 || res.status === 200) {
    emit('onCreate', res.data);
  } else {
    emit('onCreateError', res.errors);
  }
  console.log(res);
}
</script>